import React from 'react';
import styles from './InfoBanner.module.css';

export default function InfoBanner({ items = [] }) {
  return (
    <div className={styles.container}>
      {items.map((item, index) => (
        <div key={index} className={styles.item}>
          <span className={styles.label}>{item.label}</span>
          <span className={styles.value}>
            {item.icon && <span className={styles.icon}>{item.icon}</span>}
            {item.value}
          </span>
        </div>
      ))}
    </div>
  );
}
